var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.b()},[_c('div',{class:_vm.b('table-container')},[_c('table',{staticClass:"rtc-metrics-table rtc-metrics-table--striped",class:_vm.b('table')},[_c('table-head'),_c('table-body',{attrs:{"rows":_vm.rows}}),_c('table-footer',{attrs:{"totals":_vm.totals}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }